import { render, staticRenderFns } from "./OrderDetailECCode.vue?vue&type=template&id=83a44f52&scoped=true&"
import script from "./OrderDetailECCode.vue?vue&type=script&lang=js&"
export * from "./OrderDetailECCode.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailECCode.vue?vue&type=style&index=0&id=83a44f52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a44f52",
  null
  
)

export default component.exports